import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { checkPresetForCreate, checkPresetForCreateOran } from '@api/kpi';

import { ISavePresetDTO, TCreatePresetFncDTO } from '@interfaces/kpi/dto/kpiDTO';
import { ICreatePresetDTO } from '@interfaces/kpi/dto/kpiPresetsDTO';

import { CHECK_CREATE_PRESET } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCheckPresetForCreate = ({
	createPreset,
	isOranVendor,
}: {
	createPreset: UseMutateFunction<any, any, TCreatePresetFncDTO, any>;
	isOranVendor: boolean;
}) => {
	const checkPresetForCreateFunction = isOranVendor ? checkPresetForCreateOran : checkPresetForCreate;

	const {
		mutate: handleCheckCreatePreset,
		isLoading: isLoadingCheckCreatePreset,
	} = useMutation<ICreatePresetDTO>({
		mutationKey: [CHECK_CREATE_PRESET],
		mutationFn: async ({
			data,
			setNameError,
			closePresetForm,
		}: {
			data: ISavePresetDTO;
			setNameError: (message: string) => void;
			closePresetForm: () => void;
		}) => {
			try {
				await checkPresetForCreateFunction({
					name: data.name,
					isShared: data.isShared,
				});
				await createPreset({ data, closePresetForm });
			} catch (err: any) {
				setNameError(err?.errors?.[0]?.message ?? responseMessages.error);
			}
		},
	});

	return {
		handleCheckCreatePreset,
		isLoadingCheckCreatePreset,
	};
};
